import React from 'react';
import { IOption } from '../../../models/checkbox/IOption';
import { ICheckboxGroup } from '../../../models/checkbox-group/ICheckboxGroup';
import Checkbox from '../../atoms/checkbox/checkbox';
import styles from '../../atoms/checkbox/checkbox.module.scss';
import { IParentCheckboxGroup } from '../../../models/parent-checkbox-group/IParentCheckboxGroup';
import ParentCheckboxGroup from '../parent-checkbox-group/parent-checkbox-group';
// import { OnCheckNode } from "react-checkbox-tree";

type Props = {
  filter: ICheckboxGroup;
  filterNodes?: IParentCheckboxGroup;
  onChangeCheckbox?: (option: IOption, filter: ICheckboxGroup) => void;
  onFilterNodeChangeCheckbox?: (currentCheckedNode: any) => void;
};

export default function CheckboxGroup({
  filter,
  filterNodes,
  onChangeCheckbox,
  onFilterNodeChangeCheckbox,
}: Props) {
  return (
    <>
      <h4 className='font-family-lato'>{filter ? filter.name : filterNodes.name}</h4>
      {filter ? (
        filter?.options?.map((option) => (
          <div
            id={`${option.id}`}
            key={`${option.id}${option.selected}`}
            className={`${styles[`checkbox-row`]}`}
          >
            <Checkbox
              filterOption={option}
              onChange={(current: IOption) => {
                onChangeCheckbox(current, filter);
              }}
            />
          </div>
        ))
      ) : (
        <ParentCheckboxGroup
          filterNodes={filterNodes}
          onChangeCheckbox={(checkedNode: any) => {
            onFilterNodeChangeCheckbox(checkedNode);
          }}
        />
      )}
    </>
  );
}
